import { render, staticRenderFns } from "./rf.vue?vue&type=template&id=1ddc83c5&"
import script from "./rf.vue?vue&type=script&lang=js&"
export * from "./rf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports